import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import { useParams } from 'react-router-dom'
import UserForm from '../../components/forms/UserForm'
import { useGetUser } from '../../hooks/api/users'

const EditUser = () => {
  const { userId } = useParams()
  const { data: user, refetch } = useGetUser(userId)
  return (
    <Container maxWidth='md' sx={{ py: 2 }}>
      <Box mb={2}>
        <Typography variant='h5'>Edit User</Typography>
      </Box>
      {user && <UserForm user={user} refetch={refetch} />}
    </Container>
  )
}

export default EditUser
